<script lang="ts">
    import {Route} from 'svelte-routing'
    import AuthOnly from "src/components/cabinet/#common/authOnly/AuthOnly.svelte";

    export let path
    export let redirectUnAuth: string = '/login'
</script>

<Route {path} let:params={params}>
    <AuthOnly {redirectUnAuth}>
        <slot {params}></slot>
    </AuthOnly>
</Route>
